import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { notesReqApprovalActions } from '_actions';

class NotesRequiringApprovalListItem extends React.Component {
    render() {
        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };
        return (

            <div
                className={
                    this.props.message.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.message.id)}>
                {this.props.message.ptname + " - " + this.props.noteAbbrev + " " + new Date(this.props.message.noteDate).toLocaleDateString("en-US", options)}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.notesReqApproval[ownprops.id],
        noteAbbrev: state.entities.masterData.PTMASTERNOTETYPES && 
            state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesReqApproval[ownprops.id].noteType] ?
            state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesReqApproval[ownprops.id].noteType].MTABBREV :
            "",
        selectedMessage: state.ui.notesReqApproval.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(notesReqApprovalActions.changeSelection, dispatch)
    };
}

const connectedNotesRequiringApprovalListItem = connect(mapStateToProps, mapDispatchToProps)(NotesRequiringApprovalListItem);
export { connectedNotesRequiringApprovalListItem as NotesRequiringApprovalListItem };